import React, { useEffect, useMemo, useState } from 'react';
import {SelectorGruposFacturaExpatriados} from './combo';

export const SelectorGruposFacturaExpatriadosContainer = (props: any) => {
	return <SelectorGruposFacturaExpatriados {...props} />
};
